class TrainingCenterController {
  constructor(
    TrainingEntriesFactory,
    TeamsFactory,
    URLS,
    PlayersFactory,
    $filter,
    ngDialog,
    $stateParams,
    $state,
    $rootScope
  ) {
    "ngInject";
    const vm = this;

    let $translate = $filter("translate");

    let $date = $filter("date");

    const ACTIONS = {
      START: 1,
      END: 2,
      PAUSE: 3,
      UNPAUSE: 4,
      DELETE: 5,
    };

    vm.rootScope = $rootScope;

    vm.$onInit = () => {
      vm.trainingEntries = [];
      vm.reloadEntries();
    };

    vm.gridOptions = {
      paginationPageSizes: [50, 100, 150],
      paginationPageSize: 50,
      enableSorting: true,
      enableColumnMenus: false,
      enableFiltering: true,
      columnDefs: [
        {
          field: "id",
          enableFiltering: false,
          name: "ID",
          width: "70",
        },
        {
          field: "status",
          enableFiltering: false,
          name: $translate("STATUS"),
          width: "170",
          cellTemplate:
            "" +
            "<div " +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            '<div class="buttons">' +
            '<button class="btn btn-sm btn-success m-l-0" disabled translate ' +
            'ng-if="row.entity.started_at === null" ' +
            ">AVAILABLE</button>" +
            '<button class="btn btn-sm btn-info m-l-0" disabled translate ' +
            'ng-if="row.entity.started_at !== null && row.entity.ended_at === null && row.entity.paused === 0" ' +
            ">ACTIVE</button>" +
            '<button class="btn btn-sm btn-danger m-l-0" disabled translate ' +
            'ng-if="row.entity.ended_at !== null" ' +
            ">ENDED</button>" +
            '<button class="btn btn-sm btn-warning m-l-0" disabled translate ' +
            'ng-if="row.entity.paused === 1" ' +
            ">PAUSED</button>" +
            "</div>" +
            "</div>",
        },
        {
          field: "image",
          name: "",
          enableFiltering: false,
          cellTemplate:
            '<div class="ui-grid-cell-contents ui-grid-align-c p-t-0">' +
            '<span class="avatar w-32">' +
            '<img ng-src="{{grid.appScope.vm.getImage(row.entity)}}" alt="">' +
            '<i class="on b-white bottom"></i>' +
            "</span>" +
            "</div>",
          width: "80",
        },
        {
          field: "name",
          enableFiltering: true,
          name: $translate("NAME"),
          cellTemplate:
            '<div class="ui-grid-cell-contents ui-grid-align-c">{{grid.appScope.vm.getName(row.entity)}}</div>',
        },
        {
          field: "started_at",
          enableFiltering: false,
          name: $translate("STARTED_DATE"),
          width: "180",
        },
        {
          field: "ended_at",
          enableFiltering: false,
          name: $translate("ENDED_DATE"),
          width: "180",
        },
        {
          field: "created_at",
          enableFiltering: false,
          name: $translate("CREATED_AT"),
          width: "180",
        },
        {
          field: "updated_at",
          enableFiltering: false,
          name: $translate("UPDATED_AT"),
          width: "180",
        },
        {
          field: "actions",
          enableFiltering: false,
          name: $translate("ACTIONS"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            '<div class="buttons">' +
            '<button class="btn btn-sm btn-white m-l-1" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' +
            '&& row.entity.started_at === null" ' +
            'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,1)">START</button>' +
            '<button class="btn btn-sm btn-warning m-l-1" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' +
            '&& row.entity.paused === 0 && row.entity.ended_at === null && row.entity.started_at !== null" ' +
            'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,3)">PAUSE</button>' +
            '<button class="btn btn-sm btn-success m-l-1" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' +
            '&& row.entity.paused === 1" ' +
            'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,4)">UNPAUSE</button>' +
            '<button class="btn btn-sm btn-primary m-l-1" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_TRAINING_ENTRY) ' +
            '&& row.entity.ended_at === null && row.entity.started_at !== null" ' +
            'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,2)">END</button>' +
            '<button class="btn btn-sm btn-danger m-l-1" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_TRAINING_ENTRY) ' +
            '&& row.entity.ended_at === null" ' +
            'ng-click="grid.appScope.vm.actionTrainingEntry(row.entity.id,5)">DELETE</button>' +
            "</div>" +
            "</div>",
        },
      ],
    };

    vm.actionTrainingEntry = (trainingEntryId, action) => {
      let question;
      switch (action) {
        case ACTIONS.START:
          question = "START_TRAINING_ENTRY";
          break;
        case ACTIONS.END:
          question = "END_TRAINING_ENTRY";
          break;
        case ACTIONS.PAUSE:
          question = "PAUSE_TRAINING_ENTRY";
          break;
        case ACTIONS.UNPAUSE:
          question = "UNPAUSE_TRAINING_ENTRY";
          break;
        case ACTIONS.DELETE:
          question = "DELETE_TRAINING_ENTRY";
          break;
      }
      ngDialog
        .openConfirm({
          template: "confirmTemplate",
          data: {
            message: $translate(question),
          },
        })
        .then(() => {
          let promise;
          switch (action) {
            case ACTIONS.START:
              promise = TrainingEntriesFactory.start(trainingEntryId);
              break;
            case ACTIONS.END:
              promise = TrainingEntriesFactory.end(trainingEntryId);
              break;
            case ACTIONS.PAUSE:
              promise = TrainingEntriesFactory.pause(trainingEntryId);
              break;
            case ACTIONS.UNPAUSE:
              promise = TrainingEntriesFactory.unpause(trainingEntryId);
              break;
            case ACTIONS.DELETE:
              promise = TrainingEntriesFactory.delete(trainingEntryId);
              break;
          }
          promise.then((response) => {
            ngDialog.open({ template: "successTemplate" });
            vm.reloadEntries();
          });
        });
    };

    vm.hasPermission = (permission) => {
      return vm.rootScope.user.canDo(permission);
    };

    vm.getName = (entity) => {
      if (entity.player) {
        return entity.player.playerName;
      } else if (entity.coach) {
        return entity.coach.coachName;
      } else {
        return "";
      }
    };

    vm.getImage = (entity) => {
      if (entity.player && entity.player.img) {
        return URLS.IMAGES_URL + "/players/" + entity.player.img;
      } else if (entity.coach && entity.coach.img) {
        return URLS.IMAGES_URL + "/coaches/" + entity.coach.img;
      } else {
        return "assets/images/no_avatar.png";
      }
    };

    vm.reloadEntries = () => {
      TrainingEntriesFactory.getAll({ page_size: 2000, open: true }).then(
        (response) => {
          vm.trainingEntries = response.data;
          vm.gridOptions.data = response.data;
        }
      );
    };
  }
}

export default TrainingCenterController;



// WEBPACK FOOTER //
// ./client/app/components/trainingCenter/trainingCenter.controller.js